<template>
<div>
  <div class="sidebar-wrapper" :class="{'en':lang==='en','zh':lang==='zh'}">
    
    <div class="logo">
      <img src="@/assets/header-logo.png" alt="logo">
    </div>

    <ul>

      <!--首页-->
      <li class="nav-item" :class="{hover:hoverIndex===0}" @click='sideBarClick(0)' @mouseenter="visible(0)" @mouseleave="invisible(0)">
         <router-link class="nav-box item-box" to="/index" :class="{'router-link-active':'/index'===path }">
            <span>{{$t('sidebar.index')}}</span>
        </router-link>
      </li>

      <!--关于我们-->
      <li class="nav-item" :class="{hover:hoverIndex===1}" @click='sideBarClick(1)' @mouseenter="visible(1)" @mouseleave="invisible(1)">
         <router-link class="nav-box item-box" to="/about" :class="{'router-link-active':'/about'===path }">
            <span>{{$t('sidebar.about')}}</span>
        </router-link>
      </li>

      <!--展会动态-->
      <li class="nav-item" :class="{hover:hoverIndex===2}" @click='sideBarClick(2)' @mouseenter="visible(2)" @mouseleave="invisible(2)">
         <router-link class="nav-box item-box" to="/dynamic" :class="{'router-link-active':'/dynamic'===path }">
            <span>{{$t('sidebar.dynamic')}}</span>
        </router-link>
        <Submenu :children="showRouter[2].children" :icon="showRouter[2].meta.icon" @subMenuClick="subMenuClick"></Submenu>
      </li>


      <!--英文版专用 新闻-->
      <li class="nav-item" :class="{hover:hoverIndex===3}" @click='sideBarClick(3)' @mouseenter="visible(3)" @mouseleave="invisible(3)">
         <router-link class="nav-box item-box" to="/news" :class="{'router-link-active':'/news'===path }">
            <span>{{$t('sidebar.ennews')}}</span>
        </router-link>
      </li>


      <!--观展服务-->
      <li class="nav-item" :class="{hover:hoverIndex===4}" @click='sideBarClick(4)' @mouseenter="visible(4)" @mouseleave="invisible(4)">
         <router-link class="nav-box item-box" to="/service" :class="{'router-link-active':'/service'===path }">
            <span>{{$t('sidebar.service')}}</span>
        </router-link>
      </li>

      <!--海外直通车-->
      <li class="nav-item" :class="{hover:hoverIndex===5}" @click='sideBarClick(5)' @mouseenter="visible(5)" @mouseleave="invisible(5)">
         <a class="nav-box item-box" href="http://www.uniceramics.com.cn/live/playback2021.php" target="_bland">
            <span>{{$t('sidebar.overlive')}}</span>
        </a>
        <div class="sub-nav-wrapper">
          <div>
              <div class="cover"><img src="https://reg.uniceramics.com.cn/live/images/poster18.jpg?temp=0630" alt=""></div>
              <ul class="sub-nav">
                <li class="sub-nav-item" @click="subMenuClick">
                  <a href="http://www.uniceramics.com.cn/live/playback2021.php" target="_bland" class="a">{{$t('sidebar.overlive_1')}}</a>
                </li>
                <li class="sub-nav-item" @click="subMenuClick">
                  <a href="http://www.uniceramics.com.cn/live/playback.php" target="_bland" class="a">{{$t('sidebar.overlive_2')}}</a>
                </li>
              </ul>
          </div>
        </div>
      </li>


      <!--文件下载-->
      <li class="nav-item" :class="{hover:hoverIndex===6}" @click='sideBarClick(6)' @mouseenter="visible(6)" @mouseleave="invisible(6)">
         <router-link class="nav-box item-box" to="/visit" :class="{'router-link-active':'/visit'===path }">
            <span>{{$t('sidebar.isit_course')}}</span>
        </router-link>
      </li>

      <!--联系我们-->
      <li class="nav-item" :class="{hover:hoverIndex===7}" @click='sideBarClick(7)' @mouseenter="visible(7)" @mouseleave="invisible(7)">
         <router-link class="nav-box item-box" to="/contact" :class="{'router-link-active':'/contact'===path }">
            <span>{{$t('sidebar.contact')}}</span>
        </router-link>
      </li>



      <!-- <li class="nav-item" 
        :class="{hover:hoverIndex===index,hack:index===3&&lang==='en'}"
        v-for="(item,index) in showRouter" 
        :key="index" 
        @click='sideBarClick(index)' 
        @mouseenter="visible(index)" 
        @mouseleave="invisible(index)">

        <router-link class="nav-box item-box" :to="item.children[0].meta.path" :class="{'router-link-active':item.path===path}">
            <span>{{item.meta?item.meta.title : item.children[0].meta.title}}</span>
            <span>{{$t(item.meta?item.meta.key : item.children[0].meta.key)}}</span>
        </router-link>
        <Submenu v-if="item.children.length>1&&item.meta" :children="item.children" :icon="item.meta.icon" @subMenuClick="subMenuClick"></Submenu>

        <a v-if="index===4" class="nav-box item-box" href="http://www.uniceramics.com.cn/live/playback.php" target="_bland">
            <span>{{$t('btn.haiwailive')}}</span>
        </a>
      </li> -->

     <!--  <li class="nav-item i18n" >
        <a class="nav-box item-box" href="http://www.uniceramics.com.cn/live/playback.php" target="_bland">
            <span>{{$t('btn.haiwailive')}}</span>
        </a>
      </li> -->

      <!-- <li class="nav-item i18n" >
        <router-link class="nav-box item-box" to="/seller">
            <span>参展商与产品</span>
        </router-link>
      </li> -->
      <li class="nav-item i18n">
        <!-- <span class="nav-box item-box">{{$t('sidebar.language')}}</span> -->
        <a class="nav-box item-box" href="https://www.uniceramicsexpo.com/" v-if="lang==='zh'">
            <span>{{$t('sidebar.language')}}</span>
        </a>
        <a class="nav-box item-box" href="http://www.uniceramics.com.cn" v-if="lang==='en'">
            <span>{{$t('sidebar.language')}}</span>
        </a>
      </li>
    </ul>
  </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Submenu from './Submenu.vue'


export default {
  data(){
    return {
      showRouter:[],
      cheIndex:'',
      hoverIndex:''
    }
  },
  components: {Submenu},
  created(){
    const routes = this.routes
    let showRouter = [];
    this.routes.forEach((item)=>{
      if(!!!item.hidden){
        showRouter.push(item)
      }
    })

    console.log(showRouter);
    this.showRouter=showRouter;
  },
  computed: {
    routes() {
      return this.$router.options.routes
    },
    path(){
      let matched = this.$route.matched;
      if(matched[1].path==='/dynamic/detail/:id'){
        return '';
      }
      return matched[0].path;
    },
    lang(){return this.$store.state.index.lang}
  },
  methods: {
    sideBarClick(index){
      this.hoverIndex = '';
      this.cheIndex=index;
    },
    visible:function(index){
      this.sto=setTimeout(()=>{
        this.hoverIndex = index;
      },40);
    },
    invisible:function(index){
      clearTimeout(this.sto);
      this.hoverIndex = '';
    },
    subMenuClick(){
       this.hoverIndex = '';
    },
    changeLang(){
      let locale = localStorage.getItem('locale');
      let n = ''
      if(locale==='zh'){
        n = 'en'
        this.$store.commit('index/setLang','en');
      }else{
        n = 'zh'
        this.$store.commit('index/setLang','zh');
      }
      this.$i18n.locale = n;  //修改i18n的locale值，
      localStorage.setItem('locale',n);  //存入本地的locale值
      // this.$router.go(0);
      // this.$router.push({path:'/index'});
      window.location.replace("http://www.uniceramics.com.cn/index/");
    }
  },
  watch: {
    $route() {
      this.path;
    }
  }
}
</script>

<style scoped>
a:hover {
    color: #d70e19;
}
.sidebar-wrapper{width: 12.5%; height: 100vh; position: fixed; z-index: 990;}
.sidebar-wrapper:after{
    content: " ";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #fff;
    z-index: -1;
    -webkit-box-shadow: 0 0 5px 0 #99a0a7;
    box-shadow: 0 0 5px 0 #99a0a7;
}

.logo{text-align:center; /*margin: 1vw 0 1vw;*/}
.logo img{width:85%; margin:auto; margin-top:20px;}
ul{width: 100%; color: #141414; margin-top:10px;}
.nav-box{ 
    display: flex;
    justify-content: center;
    align-items: center;
    padding: .625vw .52083333vw;
    margin: 0.9vw 0;
    cursor: pointer;
    text-align: center;
    position: relative;
    font-size:0.85vw;
}
.nav-box:hover,.nav-box.router-link-active{color:#d70e19;}
.nav-box>img {
    display: inline-block;
    width: 1.04166667vw;
    height: 1.04166667vw;
    margin-right: .41666667vw;
    vertical-align: middle;
}

.nav-box.active:after,.nav-box:hover:after,.nav-box.router-link-active:after {
    content: "";
    display: block;
    position: absolute;
    top: 50%;
    margin-top: .5px;
    right: 0;
    width: 1.60416667vw;
    height: 1px;
    background-color: #d70e19;
}
.hack .nav-box.active:after,.hack .nav-box:hover:after,.hack .nav-box.router-link-active:after {
  width:1.1vw;
}

.i18n .nav-box:hover:after{display: none;}
.nav-item.hover .sub-nav-wrapper {
    left: 100%;
}
/*英文版新闻模块和中文版不一致，针对不同版本显示隐藏*/
.sidebar-wrapper.en ul>li:nth-of-type(3){display: none;}
.sidebar-wrapper.zh ul>li:nth-of-type(4){display: none;}

/*二级目录*/
.sub-nav-wrapper {
    width: 80%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: -20%;
    background: #fff;
    z-index: -2;
    -webkit-box-shadow: 0 0 5px 0 #99a0a7;
    box-shadow: 0 0 5px 0 #99a0a7;
    -webkit-transition: left .4s cubic-bezier(.645,.045,.355,1) .1s;
    transition: left .4s cubic-bezier(.645,.045,.355,1) .1s;
}
.sub-nav-wrapper>div {height: 100vh;width: 100%;overflow: hidden;}
.sub-nav-wrapper>div .cover {width: 8.125vw;margin: .78125vw auto 2vw;}
.sub-nav-wrapper>div .cover img {width: 100%;}
.sub-nav-wrapper>div .sub-nav .sub-nav-item {overflow: hidden;}
.sub-nav-wrapper>div .sub-nav .sub-nav-item>.a {display: block;text-align: center;padding: .625vw .52083333vw;margin: .67708333vw 0;cursor: pointer;position: relative;font-size:0.85vw;}
.sub-nav-wrapper>div .sub-nav .sub-nav-item>a.a:hover ,.sub-nav .router-link-active{background: #f2f3f7; color:#d70e19;}
</style>
